export const namespaced = true;

import VideoViewingPoleService from '@/services/VideoViewingPoleService.js';

export const state = {
  videoViewingPole: {},
};

export const mutations = {
  SET_VIDEO_VIEWING_POLE(state, videoViewingPole) {
    state.videoViewingPole = videoViewingPole;
  },
  UPGRADE_VIDEO_VIEWING_POLE_LEVEL() {
    // We only need to upgrade level here from the API side
  },
  CHANGE_VIDEO_VIEWING_POLE_PASSWORD() {
    // We don't store Password inside Vuex, so we don't need to do anything here
  },
};

export const actions = {
  fetchVideoViewingPole({ commit }, id) {
    return VideoViewingPoleService.get(id).then((response) => {
      commit('SET_VIDEO_VIEWING_POLE', response.data);
      return response.data;
    });
  },
  setVideoViewingPole({ commit }, pole) {
    commit('SET_VIDEO_VIEWING_POLE', pole);
  },
  upgradeVideoViewingPoleLevel({ commit }, { id, type }) {
    return VideoViewingPoleService.upgradeLevel(id, { type }).then((response) => {
      commit('UPGRADE_VIDEO_VIEWING_POLE_LEVEL');
      return response.data;
    });
  },
  changeVideoViewingPolePassword({ commit }, { id, password }) {
    return VideoViewingPoleService.changePassword(id, password).then(() => {
      commit('CHANGE_VIDEO_VIEWING_POLE_PASSWORD');
    });
  },
};

export const getters = {};
